import * as React from 'react'
import { BillingMainConnected } from './BillingMainConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const BillingMainExamples = () => {
  return (
    <div className="BillingMainExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <BillingMainConnected />
      </Provider>
    </div>
  )
}
